/** The picker's pure rules (1.J deliverable 9). */
import type { DocHitV1 } from '@codex/contracts';

export type PickerOption =
  | { readonly kind: 'doc'; readonly id: string; readonly hit: DocHitV1 }
  | {
      readonly kind: 'create';
      readonly id: string;
      readonly typeKey: string;
      readonly title: string;
    };

export const CREATE_OPTION_ID = 'create';

export function createLabel(typeKey: string, query: string): string {
  return `Create ${typeKey} “${query}”`;
}

/**
 * The canon hits without the page itself, then a last "Create" option for a non-empty query that
 * has no exact (case-insensitive) canon hit, when a create type is given and the hits are for this
 * query (`settled`): a page that exists must not be made twice while the search is still out.
 */
export function pickerOptions(
  canon: readonly DocHitV1[],
  selfId: string,
  query: string,
  createType: string | null,
  settled: boolean,
): PickerOption[] {
  const hits = canon.filter((hit) => hit.id !== selfId);
  const options: PickerOption[] = hits.map((hit) => ({ kind: 'doc', id: hit.id, hit }));
  const text = query.trim();
  if (
    settled &&
    createType !== null &&
    text !== '' &&
    !hits.some((hit) => hit.title.toLowerCase() === text.toLowerCase())
  ) {
    options.push({ kind: 'create', id: CREATE_OPTION_ID, typeKey: createType, title: text });
  }
  return options;
}
